var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.report.generatedBy === 'SUBLIME')?_c('payroll-details-report-view',{attrs:{"report":_vm.report}}):_c('patriot-payroll-details-view',{attrs:{"report":_vm.report}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }